// extracted by mini-css-extract-plugin
export default {"container":"qr-code_container__e0gAc","image":"qr-code_image__Q0bp4"};